import { useEffect, useRef } from "react";
import Communicator from "../../Helper/Communicator";
import { sanitizeInline } from "../../Helper/sanitize";
import { useRouterStore } from "../../Stores/Router";

const sanitize = (html: string): string => (html ? sanitizeInline(html) : "");

const handleClick = (e: MouseEvent, root: HTMLElement) => {
  let target = e.target as HTMLElement | null;
  while (target && target !== root) {
    if (target.hasAttribute?.("data-open-detail")) {
      e.preventDefault();
      const viewName = target.getAttribute("data-open-detail") ?? "";
      let payload: any = null;
      const raw = target.getAttribute("data-payload");
      if (raw) {
        try {
          payload = JSON.parse(raw);
        } catch {
          payload = null;
        }
      }
      if (viewName) {
        useRouterStore.getState().pushPage("custom-view", {
          viewName,
          payload,
        });
      }
      return;
    }
    if (target.hasAttribute?.("data-action")) {
      e.preventDefault();
      const actionName = target.getAttribute("data-action") ?? "";
      let actionData: any = {};
      const raw = target.getAttribute("data-action-data");
      if (raw) {
        try {
          actionData = JSON.parse(raw);
        } catch {
          actionData = {};
        }
      }
      if (actionName === "gleap-open-url" && actionData?.url) {
        Communicator.openURL(actionData.url, !!actionData.newTab);
        return;
      }
      if (actionName) {
        Communicator.runCustomAction(
          actionName,
          undefined,
          raw ? actionData : undefined,
        );
      }
      return;
    }
    target = target.parentElement;
  }
};

interface InlineHtmlProps {
  html: string;
  className?: string;
}

function InlineHtml({ html, className }: InlineHtmlProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const handler = (e: MouseEvent) => handleClick(e, el);
    el.addEventListener("click", handler);
    return () => el.removeEventListener("click", handler);
  }, []);

  return (
    <div
      ref={ref}
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitize(html) }}
    />
  );
}

export default InlineHtml;
